import { computed, watch, ref } from 'virtual-vue';
import type { AmountInputProps } from './amount-input';
import { yuan2fen, fen2Yuan } from '@tencent/wphk-utils';
import { formatAmount } from './business';

export function useAmountInput(props: AmountInputProps) {
  /** keyboard-input组件输入的值(金额值单位：元) */
  const inputValue = ref('');
  /** 通过maxlength计算金额整数部分最大输入长度，除去小数位（共3位）后剩余位数 */
  const maxIntDigits = computed(() => Math.max((props.maxlength || 0) - 3, 1));
  /** 金额数字值(金额值单位：分) */
  const amount = computed(() => yuan2fen(formatAmount(inputValue.value || '0', maxIntDigits.value)));

  /**
   * 设置输入值
   * @param amount 金额值(单位：分)
   */
  function setInputValue(amount: number) {
    let yuan = fen2Yuan(amount.toString());
    if (!props.decimal) {
      yuan = Number.parseInt(yuan, 10).toString();
    }
    // 分元转换，主要是为了获取格式化后的金额字符串
    inputValue.value = Number.parseFloat(yuan) > 0 ? yuan : '';
  }

  function initData() {
    if (props.value) {
      setInputValue(props.value);
    }
    watch(
      () => props.value,
      (newVal) => {
        const newValue = newVal || 0;
        if (newValue !== amount.value) {
          setInputValue(newValue);
        }
      },
    );
  }


  return {
    inputValue,
    amount,
    maxIntDigits,
    initData,
    setInputValue,
  };
}
